import { Badge } from '@triumph/design-system';
import { CarrierBadge } from '../noaCenter.types';
import { badgeColor } from '@/app/shared/utils/noaUtils';

interface StatusBadgeProps {
  badge: CarrierBadge;
  testId?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ badge, testId }) => (
  <Badge label={badge} color={badgeColor(badge)} data-testid={testId} />
);
